import { MobileDropdownStyled } from 'src/components';
import { FilterItems, SortItems } from './filterAndSortBlocks';

type Props = {
  isListView: boolean;
  setIsListView: React.Dispatch<React.SetStateAction<boolean>>;
};

export const MobileDropdown = ({ isListView, setIsListView }: Props) => {
  return (
    <MobileDropdownStyled>
      {(closeDropdown) => (
        <div className='w-full items-center justify-between'>
          {/* Cart Types Section */}
          <div className='flex flex-col items-start justify-center gap-0'>
            <FilterItems
              closeDropdown={closeDropdown}
              showMainLabel={true}
              isMobile={true}
            />
          </div>

          {/* Sort By Section */}
          <div className='flex flex-col items-start justify-center gap-0'>
            <SortItems handleClick={closeDropdown} includeLabel={true} />
          </div>

          {/* View Type Section - Commented out in original */}
          {/* <div className='inline-flex w-full justify-between p-2 xs:p-3'>
            <span className='whitespace-nowrap font-secondary text-primary-dark'>
              View:
            </span>
          </div>
          <div className='flex flex-col items-start gap-2 px-3 pb-6 pl-3 pr-4 font-semibold xs:px-6'>
            <button
              className={`w-full whitespace-nowrap py-0.5 text-left text-primary transition-all hover:text-primary-dark ${
                isListView
                  ? 'text-primary-dark hover:text-primary'
                  : 'text-primary hover:text-primary-dark'
              }`}
              name='ListView'
              onClick={(e) => {
                e.preventDefault();
                setIsListView(true);
              }}
            >
              List
            </button>
            <button
              className={`w-full whitespace-nowrap py-0.5 text-left text-primary transition-all hover:text-primary-dark ${
                !isListView
                  ? 'text-primary-dark hover:text-primary'
                  : 'text-primary hover:text-primary-dark'
              }`}
              name='GridView'
              onClick={(e) => {
                e.preventDefault();
                setIsListView(false);
              }}
            >
              Grid
            </button>
          </div> */}
        </div>
      )}
    </MobileDropdownStyled>
  );
};
